import { redirect } from 'react-router-dom';

export function getTokenDuration(expiration) {
  const expirationDate = new Date(expiration);
  const now = new Date();
  const duration = expirationDate.getTime() - now.getTime();
  return duration;
}

export function getAuthToken() {
  const token = localStorage.getItem('token');

  if (!token) {
    return null;
  }

  return token;
}

export function tokenLoader() {
  const token = getAuthToken();
  return token;
}

export function checkAuthLoader() {
  const token = getAuthToken();

  if (!token) {
    return redirect('/');
  }
}

export const validRoles = {
  'Vendor': 'vendors',
  'Corporation': 'corporations',
  'Administrator': 'administrators'
}